import { FC } from "react";
import styles from "./testimonials-card.module.css";
import { TestimonialsCardProps } from "./testimonials-card.types";
import { ASSETS_URL, getEnvVar } from "@commons-monorepo/index";

const TestimonialsCard: FC<TestimonialsCardProps> = ({
  testimonial,
  className,
  type
}) => {
  const domain = ASSETS_URL;
  return (
    <article
      className={`${styles.testimonialCard} ${
      type === "circle" ? styles.testimonialCardCircle : ""
      } ${className || ""}`}
      aria-label='testimonial-card'>

      <figure
        className={`${styles.testimonialImage} ${
        !testimonial.image ? styles.testimonialNotImage : ""
        }`}>

        <img
          src={
          testimonial.image ||
          `${
          getEnvVar("PUBLIC_ENV") !== "prod" ? domain : ""
          }/prod/web/testimonials-notimage.png`}

          alt={testimonial.name}
          loading='lazy' />

      </figure>
      <div
        className={`${styles.testimonialDescription} testimonialDescription`}>

        <p>"{testimonial.content}"</p>
        <p>
          <strong>{testimonial.name}</strong>
        </p>
      </div>
    </article>);

};

export default TestimonialsCard;